export const prodConfig = {
    firebaseConfig: {
        apiKey: "AIzaSyBoUeuXNhtegz0TOz1bPWCvv94QsxZ_Cfs",
        authDomain: "spiceapp-prod.firebaseapp.com",
        databaseURL: "https://spiceapp-prod.firebaseio.com",
        projectId: "spiceapp-prod",
        storageBucket: "spiceapp-prod.appspot.com",
        messagingSenderId: "61938975909"
    },
    rootPathRef: {
        path: '/clients/SpiecApp-Demo-bQ379r'
    },
    worldpay: {
        // iframeurl: 'https://hc.mercurycert.net/mobile/mCheckoutIFrame.aspx?pid=' //<=====development/test
        iframeurl: 'https://hc.mercurypay.com/mobile/mCheckoutIFrame.aspx?pid=' //<========production
    },
    icons: {
        "onItsWay": "https://res.cloudinary.com/spiceapp/image/upload/v1508424288/SpiceApp/statusIcons/OnTheWay.png",
        "orderComplete": "https://res.cloudinary.com/spiceapp/image/upload/v1508424288/SpiceApp/statusIcons/Complete.png",
        "orderReceived": "https://res.cloudinary.com/spiceapp/image/upload/v1508424288/SpiceApp/statusIcons/OrderReceived.png",
        "preparing": "https://res.cloudinary.com/spiceapp/image/upload/v1508424288/SpiceApp/statusIcons/Preparing.png",
        "readyForDelivery": "https://res.cloudinary.com/spiceapp/image/upload/v1508424288/SpiceApp/statusIcons/ReadyForDelivery.png",
        "readyForPickup": "https://res.cloudinary.com/spiceapp/image/upload/v1508424288/SpiceApp/statusIcons/ReadyforPickup.png"
    },
    cloudinarUpload: {
        cloudName: 'spiceapp',
        uploadPreset: 'nf6hnks4'
    },
    oneSignalConfig: {
        appId: '5e389b52-8418-45cc-9563-4455cbe3fca7',
        googleProjectNumber: '367885603471'
    },
    serverConfig: {
        baseUrl: 'https://us-central1-spiceapp-prod.cloudfunctions.net',
        clientId: 'SpiecApp-Demo-bQ379r'
    },
    storeInfo: {
        storeName: 'TaQeOut.com',
        shortName: 'TaQeOut',
        adminEmail: '"SpiceApp" <info@spiceapp.us>',
        orderUrl: 'https://taqeout.com/',
        privacyUrl: 'https://spiceapp.us/#privacy',
        fbUrl: 'https://facebook.com/spiceapp.us',
        storeHomePage: 'https://www.spiceapp.us',
        phImgUrl: 'https://fqz53.app.goo.gl/phImage',
        metaData: {
            description: 'Online ordering created just for you!',
            phone: '215-888-0986',
            email: 'demo@orders.spiceapp.us',
            keywords: 'restaurants near me, order online, contact less dine-in, kiosk ordering'
        }
    },
    googleId: {
        clientId: '367885603471-o3j9l37o2d0df6f7m9rv4i30p3h3f9kt.apps.googleusercontent.com',
        gaID: 'UA-34334825-5'
    },
    facebookId: {
        appId: '1911397465765652',
        ver: 'v2.10'
    },
    finixConfig: {
        environment: 'live',
        applicationID: 'APvhi3eRvzgTmvSMD7w4Cy1g'
    }
}


// WEBPACK FOOTER //
// ./src/app/settings-config/settings.config.prod.ts